/* eslint max-len: "off" */
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { UserStore } from '@reverbdotcom/discovery-ui';

import * as mobileAppImgSrc from '../../../images/promo/reverb-app-mini.svg';
import * as appleBadgeDe from '../../../images/promo/app-store-badges/apple-app-store-de.svg';
import * as googleBadgeDe from '../../../images/promo/app-store-badges/google-play-store-de.svg';
import * as appleBadgeEn from '../../../images/promo/app-store-badges/apple-app-store-en.svg';
import * as googleBadgeEn from '../../../images/promo/app-store-badges/google-play-store-en.svg';
import * as appleBadgeEs from '../../../images/promo/app-store-badges/apple-app-store-es.svg';
import * as googleBadgeEs from '../../../images/promo/app-store-badges/google-play-store-es.svg';
import * as appleBadgeFr from '../../../images/promo/app-store-badges/apple-app-store-fr.svg';
import * as googleBadgeFr from '../../../images/promo/app-store-badges/google-play-store-fr.svg';
import * as appleBadgeIt from '../../../images/promo/app-store-badges/apple-app-store-it.svg';
import * as googleBadgeIt from '../../../images/promo/app-store-badges/google-play-store-it.svg';
import * as appleBadgeJa from '../../../images/promo/app-store-badges/apple-app-store-ja.svg';
import * as googleBadgeJa from '../../../images/promo/app-store-badges/google-play-store-ja.svg';

const LOCALE_TO_APPLE_BADGE = {
  de: appleBadgeDe,
  en: appleBadgeEn,
  es: appleBadgeEs,
  it: appleBadgeIt,
  fr: appleBadgeFr,
  ja: appleBadgeJa,
};

const LOCALE_TO_GOOGLE_BADGE = {
  de: googleBadgeDe,
  en: googleBadgeEn,
  es: googleBadgeEs,
  fr: googleBadgeFr,
  it: googleBadgeIt,
  ja: googleBadgeJa,
};

class MobileAppAds extends React.Component {
  static renderHeading() {
    return I18n.t('js.mobileAppAds.headingExp2');
  }

  static renderSubheading() {
    return I18n.t('js.mobileAppAds.subheadingExp2');
  }

  renderAppleAppStoreLinkedBadge() {
    const imgSrc = `${LOCALE_TO_APPLE_BADGE[UserStore.getState().locale && UserStore.getState().locale.slice(0, 2)] ||
      appleBadgeEn}`;

    return (
      <a
        href={`${this.props.iosAppUrl}?pt=2069466&ct=checkout-app-install-ad&mt=8`}
      >
        <img
          src={imgSrc}
          alt={I18n.t('js.mobileAppAds.iosAlt')}
          className="width-100"
        />
      </a>
    );
  }

  renderGooglePlayStoreLinkedBadge() {
    const imgSrc = `${LOCALE_TO_GOOGLE_BADGE[UserStore.getState().locale] ||
      googleBadgeEn}`;

    return (
      <a
        href={`${this.props.androidAppUrl}&utm_source=reverb_website&utm_campaign=checkout_app_download&utm_medium=website_banner&utm_content=checkout-ad`}
      >
        <img
          src={imgSrc}
          alt={I18n.t('js.mobileAppAds.androidAlt')}
          className="width-100"
        />
      </a>
    );
  }

  render() {
    return (
      <div className="d-flex mobile-d-block fx-align-center fx-justify-center mlr-auto bg-orange plr-2 pt-2 mobile-pb-2 bd-rounded scaling-mtb-4">
        <div className="fx-width-20 plr-1 fx-align-self-end mobile-mb-2">
          <img
            src={mobileAppImgSrc}
            alt={I18n.t('js.mobileAppAds.reverbAppIllustration')}
            className="width-90 mobile-width-50 mlr-auto d-block"
          />
        </div>
        <div className="fx-width-30 plr-1 pb-1 mlr-auto mobile-pr-0 mobile-mb-1 mobile-align-center mobile-width-80">
          <h3 className="weight-bold size-130 color-white pb-half">
            {MobileAppAds.renderHeading()}
          </h3>
          <p className="mb-0 lh-130 weight-bold color-black">
            {MobileAppAds.renderSubheading()}
          </p>
        </div>
        <ul className="fx-width-40 plr-1 d-flex mobile-align-center mobile-d-block">
          <li className="fx-width-50 mr-1 mobile-mr-0 mobile-mb-1 mobile-width-50 mobile-mlr-auto">
            {this.renderAppleAppStoreLinkedBadge()}
          </li>
          <li className="fx-width-50 mobile-width-50 mobile-mlr-auto">
            {this.renderGooglePlayStoreLinkedBadge()}
          </li>
        </ul>
      </div>
    );
  }
}

MobileAppAds.propTypes = {
  iosAppUrl: PropTypes.string.isRequired,
  androidAppUrl: PropTypes.string.isRequired,
};

export default MobileAppAds;



// WEBPACK FOOTER //
// ./javascripts/components/bundled_checkout/mobile_app_ads.jsx